/* global Sys, Core, Resources */
Sys.ns("Core");

/**
 * The G4 model.
 *
 * @class Core.G4Model
 * @extends Core.Model
 */
Core.G4Model = {

    /**
     * @inheritdoc
     */
    constructor: function() {
        Core.G4Model.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    setupData: function() {
        var parsedInitResponse = Resources.readData("gameServerInitResponseObject") || {};

        this.storeData("isG4", parsedInitResponse.g4mode);
        this.storeData("isNewRound", false);
        this.storeData("disabledDuringRound", false);

        if (parsedInitResponse.g4mode) {
            this.storeData("g4RoundTimeLimit", 3000);
            this.storeData("g4QuickSpinActive", false);
            this.storeData("g4QuickSpinAvailable", false);
            this.storeData("g4QuickStopAvailable", false);
            this.storeData("g4ClockRequired", true);
        }
        else if (this.isG4PropertyDefined()) {
            this.storeData("g4RoundTimeLimit", parseInt(Sys.utils.getOssParameter("minimumRoundDuration", parsedInitResponse.config.gameParameters.minimumRoundDuration), 10));
            this.storeData("g4QuickSpinActive", Sys.utils.getOssParameter("quickSpinActive", parsedInitResponse.config.gameParameters.quickSpinActive));
            this.storeData("g4QuickSpinAvailable", Sys.utils.getOssParameter("quickSpinAvailable", parsedInitResponse.config.gameParameters.quickSpinAvailable));
            this.storeData("g4QuickStopAvailable", Sys.utils.getOssParameter("quickStopAvailable", parsedInitResponse.config.gameParameters.quickStopAvailable));
            this.storeData("g4ClockRequired", parsedInitResponse.config.gameParameters.clockRequired);
        }

        this.storeData("G4Config", this.setupConfig());
    },

    /**
     * Sets up configuration for G4.
     *
     * @returns {Object} G4 Configuration.
     */
    setupConfig: function() {
        var me = this;

        return {
            minGameRoundDuration: me.readData("g4RoundTimeLimit"),
            settings: [
                {
                    name: "quickSpin",
                    enabled: me.readData("g4QuickSpinAvailable"),
                    offValue: false
                }
            ],
            modules: [
                {
                    name: "systemClock",
                    enabled: me.readData("g4ClockRequired")

                },
                {
                    name: "quickStopper",
                    enabled: me.readData("g4QuickStopAvailable")
                }
            ]
        };
    },

    /**
     *
     * Checks if minimum round time enforcement is required between rounds.
     *
     * @returns {boolean} Enforcement required or not.
     */
    isEnforcementRequired: function() {
        var me = this;

        return me.readData("isG4") || !(typeof me.readData("g4RoundTimeLimit") === "undefined");
    },

    /**
     * Checks if any of the G4 properties is defined or not.
     *
     * @returns {boolean} Property exists or not.
     */
    isG4PropertyDefined: function() {
        var parsedInitResponse = (Resources.readData("gameServerInitResponseObject") || {}),
            quickSpinActiveServer, quickSpinAvailableServer, quickStopAvailableServer, clockRequiredServer, minimumRoundDurationServer;

        if (Sys.isDefined(parsedInitResponse.config) && Sys.isDefined(parsedInitResponse.config.gameParameters)) {
            quickSpinActiveServer = parsedInitResponse.config.gameParameters.quickSpinActive;
            quickSpinAvailableServer = parsedInitResponse.config.gameParameters.quickSpinAvailable;
            quickStopAvailableServer = parsedInitResponse.config.gameParameters.quickStopAvailable;
            clockRequiredServer = parsedInitResponse.config.gameParameters.clockRequired;
            minimumRoundDurationServer = parsedInitResponse.config.gameParameters.minimumRoundDuration;
        }

        return (Sys.isDefined(Sys.utils.getOssParameter("quickSpinActive", quickSpinActiveServer)) ||
            Sys.isDefined(Sys.utils.getOssParameter("quickSpinAvailable", quickSpinAvailableServer)) ||
            Sys.isDefined(Sys.utils.getOssParameter("quickStopAvailable", quickStopAvailableServer)) ||
            Sys.isDefined(clockRequiredServer) ||
            Sys.isDefined(Sys.utils.getOssParameter("minimumRoundDuration", minimumRoundDurationServer)));
    },

    /**
     * Calculates the extension time in ms (for reaching roundTimeLimit).
     *
     * @returns {number} Minimum time left.
     */
    getMinimumTimeLeft: function() {
        var minimumRoundTime = this.getRoundStartTime() + this.readData("g4RoundTimeLimit"),
            timeLeft = minimumRoundTime - Date.now();

        return timeLeft > 0 ? timeLeft : 0;
    },

    /**
     * Configuration changes for g4mode.
     *
     * @returns {number} New round.
     */
    isNewRound: function() {
        return this.readData("isNewRound");
    },

    /**
     * Set's the start time for a new round.
     *
     * @returns {void}
     */
    setRoundStartTime: function() {
        var now = Date.now();

        this.storeData("roundStartTime", now);
    },

    /**
     * @returns {number} Round start time.
     */
    getRoundStartTime: function() {
        return this.readData("roundStartTime");
    },

    /**
     * Returns the specific configuration.
     *
     * @param {string} name Name.
     * @returns {Object|undefined} G4 configuration.
     */
    getG4Config: function(name) {
        var config = this.readData("G4Config");

        if (config.hasOwnProperty(name)) {
            return config[name];
        }

        return undefined;
    }
};

Core.G4Model = Sys.extend(Core.Model, Core.G4Model, "Core.G4Model");
